import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ y }}
    whileInView={{ y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, titleEm, light = false, className = "" }) => (
  <Reveal className={className}>
    <p className={`eyebrow ${light ? "text-[#E9C46A]" : "text-[#721121]"}`}>{eyebrow}</p>
    <h2 className={`font-display mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight ${light ? "text-white" : "text-[#1C1917]"}`}>
      {title} <em className={`italic ${light ? "text-[#E9C46A]" : "text-[#721121]"}`}>{titleEm}</em>
    </h2>
  </Reveal>
);
